﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_searchEventListItem from './tpl/searchEventListItem.html';

export default Marionette.ItemView.extend({
    tagName: 'Div',
    className :'col-6 col-sm-5 col-md-4 col-lg-3 col-xl-2',
    getTemplate: function () {
        return tpl_searchEventListItem({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'searchEventListItem_btnDetails': '#searchEventListItem_btnDetails'
    },
    events: {
        'click @ui.searchEventListItem_btnDetails': 'details'
    },
    details: function (event) {
        app.router.navigate("#searchEventListItemDetails/" + this.model.id);
        app.router.searchEventListItemDetails(this.model.id);
    }
});